import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { cookiesPolicy } from '../cookiesPolicy';

function PoliCookies() {
  const { i18n } = useTranslation();

  // Log para verificar a lista de políticas de cookies
  console.log('cookiesPolicy:', cookiesPolicy);

  return (
    <div className='container Cookies'>
      <div className='text'>
        {cookiesPolicy.map((item, index) => {
          // Verificar se item.text e item.text[i18n.language] existem
          const language = i18n.language;
          const text = item.text && item.text[language];
          return (
            <div className="poli-cookies" key={index}>
              <Trans
                i18nKey={`cookiesPolicy_${index}`}
                components={{
                  1: <p />,
                  2: <h4 />,
                  3: <p />,
                  4: <em />,
                }}
              >
                {text ? text.replace(/&nbsp;/g, ' ') : `Texto não disponível para a linguagem ${language}`}
              </Trans>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default PoliCookies;